module.exports = __webpack_public_path__ + "static/media/User.7373c731.svg";